import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["headerFont", "root"]
  setHeaderFont() {
    const selectedOption = this.headerFontTarget.selectedOptions[0] // <option value="roboto" data-font-name="Roboto">Roboto</option>

    const headerFont = selectedOption.dataset.fontName

    this.rootTarget.style.setProperty("--site-font-family-header", headerFont)
  }
}
